
export default function VerticalSeparator() {
    return (<div style={{position: "relative", left: "50%", borderLeft: "2px solid", height: "100%"}}/>)
}